import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputGroupV2 from '../InputGroupV2';
import InputFormatV2 from '../InputFormatV2';
import {
  DEFAULT_PICKER_ERROR_MESSAGE,
  pickerOpenButtonSlotProps,
  pickerTextFieldSlotProps,
} from '../formFieldStyles';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

const picker = (onChange, value, disabled, error) => (
  <>
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
      <DatePicker
        format="DD/MM/YYYY"
        value={
          value && typeof value !== 'function' ? moment(value) : null
        }
        onChange={(v) => onChange(v ? v.valueOf() : null)}
        disabled={disabled}
        slotProps={{
          openPickerButton: pickerOpenButtonSlotProps,
          textField: pickerTextFieldSlotProps({
            disabled,
            error,
            helperText: DEFAULT_PICKER_ERROR_MESSAGE,
          }),
        }}
      />
    </LocalizationProvider>
  </>
);

const input = (onChange, label, value, disabled, error, yearMonth) => {
  let dateValue = null;
  if (value && !String(value).includes('/')) {
    dateValue = moment(value).format(yearMonth ? 'MM/YYYY' : 'DD/MM/YYYY');
  }

  return (
    <InputFormatV2
      error={error}
      helperText={error ? DEFAULT_PICKER_ERROR_MESSAGE : ''}
      label={label}
      value={dateValue}
      onChange={(event) => {
        let eventValue = event.target.value;
        if (yearMonth && event.target.value.length === 7) {
          eventValue = moment(event.target.value, 'MM/YYYY').valueOf();
        } else if (event.target.value.length === 10) {
          eventValue = moment(event.target.value, 'DD/MM/YYYY').valueOf();
        }

        onChange(eventValue);
      }}
      disabled={disabled}
      format={yearMonth ? '##/####' : '##/##/####'}
      showInputGroup={false}
    />
  );
};

const DatePickerV2 = ({
  onChange,
  value,
  label,
  disabled,
  isRequired,
  error,
  showInput,
  yearMonth,
}) => (
  <InputGroupV2 label={label} isRequired={isRequired}>
    {showInput && input(onChange, label, value, disabled, error, yearMonth)}
    {!showInput && picker(onChange, value, disabled, error)}
  </InputGroupV2>
);

DatePickerV2.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isRequired: PropTypes.any,
  error: PropTypes.bool,
  showInput: PropTypes.bool,
  yearMonth: PropTypes.bool,
};

DatePickerV2.defaultProps = {
  value: null,
  disabled: false,
  isRequired: false,
  error: false,
  showInput: false,
  yearMonth: false,
};

export default DatePickerV2;
